import React, { useState, useEffect } from 'react';
import { Box, Typography, Button, Grid } from '@mui/material';
import TimerTile from './TimerTile';
import { getText } from '../../libs/utils';

const PayByWidget = ({ order, handleTimeOut }) => {

  useEffect(() => {
    openWidget();
  }, []);

  const openWidget = () => {
    const { deposits } = order;
    if (deposits[0] && deposits[0].tabs) {
      const widgetData = deposits[0].tabs[0].outputs.find(el => el.type == "widget")

      if (widgetData.value.paymentSystem == "Itez") {
        if (window.ItezWidget) {
          window.ItezWidget.run(JSON.parse(widgetData.value.widgetParams))
        } else {
          var script = document.createElement('script');
          script.onload = () => {
              window.ItezWidget.run(JSON.parse(widgetData.value.widgetParams))
          };
          script.src = widgetData.value.script;
          document.head.appendChild(script);
        }
      }
    } else {
      setTimeout(() => this.openWidget(), 5000);
    }
  }

  return (
    <>
      <Box sx={{ display: 'flex', justifyContent: 'space-between'}}>
        <Typography variant="h3">{getText('payMerchTopHeader')}</Typography>
        <TimerTile timerEnd={order.endAt} handleTimeOut={handleTimeOut} />
      </Box>

      <Typography variant="regularCaption" component="div">
      {getText('payMerchText01')} <Typography variant="link" onClick={() => openWidget()} sx={{textTransform: 'none', fontSize: '14px'}}>{getText('payMerchText02')}</Typography> {getText('payMerchText03')}</Typography>

      <div id="itez-widget-container"></div>
    </>
  )
}

export default PayByWidget